module.exports = __webpack_public_path__ + "img/L_2H.4161b16e.png";